import React from 'react';
import './../../css/CardRedirection.css';
import {Logo} from './../../components/common/Logo/Logo.js';
import {connect} from 'react-redux';
import {OnTechDiffPageLoad,OnTechDiffCancel} from './../../components/SiteCat/SiteCat'
import {getMerchantData,onServerError} from './../../constants/merchantData';

class TechDiff extends React.Component{

  constructor() {
    super();

    this.state = {
      merchantName:"",
      authCode:"" 
    };
  }

  componentWillMount = () => {
    this.setState({
      merchantName : this.props.lockedposts.merchant,
      authCode : this.props.lockedposts.authcode
    });
  }

  componentDidMount() {
    OnTechDiffPageLoad(this.state.merchantName);
    const cancelUrlData = this.props.lockedposts.cancelUrl ;
    this.setState({
      cancelUrlData
    });
  }
  handleCancel = event => {
    OnTechDiffCancel(this.state.merchantName);
    let data = {
      merchantName: this.state.merchantName,
      cancelUrlData: this.state.cancelUrlData,
      authCode: this.state.authCode 
    }
    onServerError(data);
  }


  render() {
    const merchantData = getMerchantData(this.state.merchantName)
    return(
      <React.Fragment>
      <div className="row">
          <div className="col-xs-12 col-sm-8 col-md-8 col-lg-4 col-md-offset-2 col-lg-offset-4 col-sm-offset-2">
            <div className="tech-diff-header">{merchantData.TechDiff.HEADER}</div>
            <div className="tech-diff-section">{merchantData.TechDiff.MESSAGE}</div>
            <div className="tech-diff-cancel"><button class="changebtnproperty" onClick={this.handleCancel}>{merchantData.TechDiff.LINK}</button></div>
          </div>
        </div>
        </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lockedposts: state
  }
}

export default connect(mapStateToProps)(TechDiff);
